import { db } from "../../../config/firebase/firebase-config";
import { TypeUser } from "../../../enums/enums";
import { IUserForm } from "../form/IUsersForm";
import { ApiResponse } from "../../../services/ApiResponse";
import { IUserDoc } from "../doc/IUserDoc";
import { IValidateOffice } from "../form/IValidateOffice";

// Obtener usuario por documento
export const getUserByDocument = async (document: number, idEntity: string) => {
  const usersSnap = await db
    .collection("Users")
    .where("rol", "==", TypeUser.OFFICER)
    .where("document", "==", document)
    .where("idEntity", "==", idEntity)
    .get();
  const users: any[] = [];

  usersSnap.forEach((snap) => {
    users.push({
      ...snap.data(),
    });
  });
  return users;
};

// Obtener usuario por documento
export const getUserByEmail = async (email: string, idEntity: string) => {
  const usersSnap = await db
    .collection("Users")
    // .where("rol", "==", TypeUser.OFFICER)
    .where("email", "==", email)
    // .where("idEntity", "==", idEntity)
    .get();
  const users: any[] = [];

  usersSnap.forEach((snap) => {
    users.push({
      ...snap.data(),
    });
  });
  return users;
};

// Obtener usuario por ID
export const getUserById = async (id: string) => {
  const usersSnap = await db.collection("Users").doc(id).get();
  return usersSnap.data();
};

// Agregar usuario a la colección de usuarios
export const addUser = async (user: IUserDoc) => {
  // Crea una referencia al nuevo documento con un ID automático
  const newDocRef = db.collection("Users").doc();

  // Agrega el ID generado automáticamente al objeto user
  user.id = newDocRef.id;

  // Guarda el usuario en Firestore con el nuevo ID
  await newDocRef.set(user);
};

// Get usuarios por entidad admin
export const getUsersByEntity = async (idEntity: string) => {
  const usersSnap = await db
    .collection("Users")
    .where("rol", "==", TypeUser.OFFICER)
    .where("idEntity", "==", idEntity)
    .get();
  const users: IUserForm[] = [];

  usersSnap.forEach((snap: any) => {
    users.push({
      ...(snap.data() as IUserForm),
    });
  });

  return users;
};

// Editar usuario en colección Users
export const editUser = async (user: IUserDoc) => {
  await db.collection("Users").doc(user.id).update(user);
};

// Asignar módulos
export const assignModulesUser = async (user: IUserForm, modules: string[]) => {
  await db
    .collection("Users")
    .doc(user.id.toString())
    .set({ modules, id: user.id.toString() }, { merge: true });
};

// Asignar oficinas
export const assignOfficesUser = async (idUser: string, offices: string[]) => {
  await db
    .collection("Users")
    .doc(idUser)
    .set({ offices, id: idUser.toString() }, { merge: true });
};

export const restricUser = async (user: {
  id: string;
  restricUser: boolean;
}): Promise<ApiResponse> => {
  try {
    await db
      .collection("Users")
      .doc(user.id)
      .update({ restricUser: user.restricUser });
    return {
      ok: true,
      data: null,
      message: "Recurso actualizado con exito."
    }
  } catch(exception) {
    return {
      ok: false,
      data: null,
      message: exception
    }
  }
};

// elimina usuario en colección Users
export const deleteUser = async (user: any) => {
  const querySnapshot = await db
    .collection("Users")
    .where("uid", "==", user.uid)
    .get();

  if (querySnapshot.empty) {
    return null;
  }
  const deletePromises = querySnapshot.docs.map((doc) => doc.ref.delete());
  return true;
};

// elimina usuario en colección Users
export const validateOfficeUser = async (
  data: IValidateOffice
): Promise<any[]> => {
  try {
    const querySnapshot = await db
      .collection("Users")
      .where("offices", "array-contains", data.office.idOffice)
      .get();

    let usuarios: any[] = [];

    if (querySnapshot.empty) {
      return [];
    }

    querySnapshot.forEach((doc) => {
      usuarios.push(doc.data()); 
    });

    return usuarios;
  } catch (error) {
    console.error("Error al obtener documentos:", error);
    return [];
  }
};
